import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MetricBulkRequestCompanyWrapper } from "../../dto/metric-bulk-request";
import { SharedComponentsModule } from "../../../shared/module/shared-components.module";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SpinnerProps } from "../../../shared/component/modal-container/modal-container.component";

@Component({
  selector: 'app-kpi-modal-msl-update-contact',
  standalone: true,
  imports: [
    SharedComponentsModule,
  ],
  templateUrl: './kpi-modal-msl-update-contact.component.html',
  styleUrl: './kpi-modal-msl-update-contact.component.scss',
})
export class KpiModalMslUpdateContactComponent implements OnChanges {
  @Input({ required: true }) companyForm: MetricBulkRequestCompanyWrapper;
  @Output() closeEmitter = new EventEmitter<boolean>();

  contactPersonForm: FormGroup<{
    name: FormControl<string>,
    email: FormControl<string>,
  }>;

  spinnerProps: SpinnerProps = {
    isSpinnerActive: false,
    notActiveOnApply: true,
  };

  ngOnChanges(): void {
    this.setContactPersonForm();
  }

  resetPerson(): void {
    this.spinnerProps = {
      isSpinnerActive: true,
      notActiveOnApply: true,
    };
    this.companyForm.linkForm.form.controls.contact.controls.name.patchValue(null);
    this.companyForm.linkForm.form.controls.contact.controls.email.patchValue(null);
    this.companyForm.linkForm.form.controls.contact.controls.isActivated.patchValue(false);
    this.close(true);
  }

  apply(): void {
    this.spinnerProps = {
      isSpinnerActive: true,
      notActiveOnApply: true,
    };
    const contact = this.contactPersonForm.value;
    this.companyForm.linkForm.form.controls.contact.controls.name.patchValue(contact.name);
    this.companyForm.linkForm.form.controls.contact.controls.email.patchValue(contact.email);
    this.companyForm.linkForm.form.controls.contact.controls.isActivated.patchValue(true);
    this.close(true);
  }

  close(isSuccessful: boolean): void {
    this.closeEmitter.emit(isSuccessful);
  }

  private setContactPersonForm(): void {
    const contactPerson = this.companyForm.linkForm.getFormRawValue().contact;
    this.contactPersonForm = new FormGroup({
      name: new FormControl<string>(contactPerson.name),
      email: new FormControl<string>(contactPerson.email, { validators: [ Validators.email] }),
    });
  }
}

